import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=d2864684&"
import script from "./Todos.vue?vue&type=script&lang=js&"
export * from "./Todos.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/app.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports